import React from "react";
import './BestUnis.css';

class BestUnis extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">كيفية معرفة افضل الجامعات فى المانيا</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        السلام عليكم
                                        <br/>
                                        الشباب اللى بيهتم بأحسن و أفضل الجامعات فى المانيا بالنسبة لمجال معين او كإسم الجامعة و ترتيبها على مستوى العالم و فى ألمانيا
                                        <br/>
                                        Rankingفأفضل مواقع لل
                                        <br/>
                                        تعتبر هى دى
                                        <br/>
                                        <div className='lft'>
                                            = <a target='_blank' rel='noreferrer' href='https://ranking.zeit.de/che/en/'>ranking.zeit.de/che</a>
                                        <br/>
                                            = <a target='_blank' rel='noreferrer' href='https://www.topuniversities.com/university-rankings'>topuniversities.com/university-rankings</a>
                                        <br/>
                                            = <a target='_blank' rel='noreferrer' href='https://www.timeshighereducation.com/content/world-university-rankings'>timeshighereducation.com/../world-university-rankings</a>
                                        <br/>
                                            = <a target='_blank' rel='noreferrer' href='https://www.webometrics.info/en'>webometrics.info</a>
                                        </div>
                                        كل اللى عليك انك هتدخل على كل موقع و هتختار البلد اللى عايز تشوف ترتيب الجامعات فيها ..و تختار التخصص اللى عايز تدرسه و هيظهرلك احسن الجامعات .. ترتيب الجامعة بيشمل حاجات كتير و هتلاقيها بالتفصيل فى الموقع 
                                        <br/>
                                        هتقابل جامعة ممكن تبقا الأولى فى المانيا فى تخصص معين و فى مجال تانى مش مصنفة من افضل الجامعات  فمتستغربش
                                        <br/>
                                        ممكن تلاقى جامعة ترتيبها فى موقع مختلف عن موقع تانى .. لان كل موقع له أساسيات للترتيب فمتستغربش برضه
                                        <br/>
                                        DAAD و دة <a target='_blank' rel='noreferrer' href='https://www.daad.de/en/study-and-research-in-germany/plan-your-studies/che-university-ranking/'>لينك</a> من منظمة
                                        <br/>
                                        عن الجامعات فى المانيا و معلومات عن كل جامعة
                                        <br/>
                                        .و كل تخصص
                                        <br/>
                                        حاول متركزش مع ترتيب الجامعات .. مثلا جامعات الهوخ شولا "التطبيقية " ممكن متبقاش مصنفة من افضل الجامعات فى المانيا بس فى الواقع هى مفيدة لتخصصات معينة زى تخصصات الهندسة مثلا
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default BestUnis;
